import StandardError from '@/modules/errors/Standard'

class UnauthorizedError extends StandardError {
  constructor(
    message = 'User is not authenticated',
    status = 401,
    body: Record<string, unknown> = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default UnauthorizedError
